import { RootState } from "../../reducers";

export const disableSaveButtonSelector = (state: RootState): boolean =>
  state.documentEditing.disableSaveButton;
